import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from "./EmergencyTreatmentPDFStyle";
import { IAddress } from '../../../models/IAddress';

interface IEmergencyTreatmentPDFTreatingCareProvider {
    treatingCareProviderName: string;
    treatingCareProviderAddress: IAddress | undefined;
    dentistName: string;
    dentistPhoneNumber: string;
    externalId: string;
    renderInformationField: (label: string, value: string | undefined) => void;
    formatAddress: (address: IAddress | undefined) => string;
}

export const EmergencyTreatmentPDFTreatingCareProvider: React.FunctionComponent<IEmergencyTreatmentPDFTreatingCareProvider> = ({ treatingCareProviderName, treatingCareProviderAddress, dentistName, dentistPhoneNumber, externalId, renderInformationField, formatAddress }) => {
    return (
        <View style={[styles.smallBox, { borderWidth: 1 }]}>
            <Text style={[styles.headerTwo, { marginBottom: "5px" }]}>Fakturerande vårdgivare</Text>
            {
                renderInformationField("Vårdgivarnamn", treatingCareProviderName)
            }
            {
                renderInformationField("Adress", formatAddress(treatingCareProviderAddress))
            }
            {
                renderInformationField("Behandlare", dentistName)
            }
            {
                renderInformationField("Eget referens-ID", externalId)
            }
        </View>
    )
}